import { PriceStatus, Status } from '@toggle/helpers';
import styled from 'styled-components';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { priceChangeColors } from '~/utils/common/utils';

export const StyledTooltip = styled(TooltipContainer)``;

export const PriceWrapper = styled.div<{
  $status: PriceStatus | Status;
  $alignment?: string;
}>`
  color: ${({ $status }) => priceChangeColors[$status]};
`;

export const Unit = styled.span`
  font-size: 8px;
  line-height: 12px;
  margin-top: 6px;
  margin-left: 5px;
`;
